<!-- Your component's HTML file -->
<form class="dscr-industry-ebitda-selection-component" [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Industry EBITDA</mat-label>
    <mat-select [formControl]="formControl" placeholder="Select ebitda..." [compareWith]="compareWithFn">
      @for (industryEbitda of industryEbitdas; track industryEbitda) {
        <mat-option [value]="industryEbitda">
          {{industryEbitda.name}} - {{industryEbitda.percentage}}%
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</form>
